import { cannectDefaultProduct, cannectDefaultProductNoTarg } from 'assets/img'
import ModalEditProduct from 'components/ModalEditProdruct'
import useMediaQuery from 'hooks/useMediaQuery'
import { usePrepareCart } from 'hooks/usePrepareCart'
import useSignedUser from 'hooks/useSignedUser'
import { SoldByPill } from 'new-components/atoms'
import { FlavorQuantitySelector } from 'new-components/FlavorQuantitySelector'
import { ProgressiveDiscountBadge } from 'new-components/ProgressiveDiscountBadge'
import { ProgressiveSingleQuantityControl, useProgressiveUnitPrice } from 'new-components/ProgressiveQuantityDropdown'
import PromotionalPrice from 'new-components/MarketPlace/PromotionalPrice'
import { useState } from 'react'
import { MOBILE_WIDTH } from 'utils/constants'
import { formatPriceToNumber } from 'utils/formatters'
import { getManualUnitPrice, isManualPriceItem } from 'utils/manualPrice'
import * as Style from './styles'

interface PropsProduct {
  product_id: number
  amount: number
  unitPrice: number
  quantity: number
  image: string
  name: string
  id: number
  product: any
  promotion: any
  stock?: number
  main_product_id?: number
  class_id?: number
}

interface ItemPropProduct {
  product: PropsProduct
  isNotEditing?: boolean
  isNotEditingFlavor?: boolean
  isCarrinhoWa?: boolean
}

export function CardProduct({ product, isNotEditing, isNotEditingFlavor, isCarrinhoWa }: ItemPropProduct) {
  const { id, quantity, product_id, unitPrice } = product
  const effectiveUnitPrice = useProgressiveUnitPrice(product_id, quantity, unitPrice)
  const isManualPrice = isManualPriceItem(product)
  // Progressivo só vence a promoção quando de fato reduziu o preço (faixa atingida sobre unitPrice).
  const isProgressiveActive = !isManualPrice && effectiveUnitPrice < unitPrice
  const promotionalPrice = product?.promotion?.promotional_price
  const hasPromotion = !isManualPrice && !!promotionalPrice

  let displayPrice: number = isManualPrice ? getManualUnitPrice(product) : unitPrice
  let priceOldValue: number | undefined
  let priceDiscount: number | string | undefined
  let priceDiscountType: string | undefined

  if (isProgressiveActive) {
    displayPrice = effectiveUnitPrice
    priceOldValue = unitPrice
    priceDiscount = Math.round(((unitPrice - effectiveUnitPrice) / unitPrice) * 100)
    priceDiscountType = 'percent'
  } else if (hasPromotion) {
    displayPrice = promotionalPrice
    priceOldValue = product?.promotion?.regular_price
    priceDiscount = product?.promotion?.discount_value
    priceDiscountType = product?.promotion?.discount_type
  }
  const { removeCart, incrementOrDecrementCart, isUpdate } = usePrepareCart()
  const [openModal, setOpenModal] = useState(false)
  const { signedUser } = useSignedUser()

  const isPatientUserType = signedUser?.registration_type === 1

  const isPill = product?.product?.origin === 'pill'

  const imagePath = product?.product?.media
    ? product?.product?.media.filter((value: any) => value.format === 'IMG').sort((a: any, b: any) => a.id - b.id)
    : product?.image
  const flavors = product?.product?.flavors || []
  const flavorSelected = flavors?.find((value: any) => value.id === product?.product.id)

  async function handleSelect(newQuantity: any) {
    if (newQuantity === 0) {
      removeCart(product_id)
      return
    }
    incrementOrDecrementCart(product_id, newQuantity)
  }

  const isMobile = useMediaQuery(MOBILE_WIDTH)

  const total = product?.amount ? product.amount : 0
  const defaultImage = product?.product?.supplier?.id === 18 ? cannectDefaultProduct : cannectDefaultProductNoTarg
  const selectedImage = isPill
    ? product?.product?.media?.[0]?.path || product?.image || undefined
    : isPatientUserType && !(product?.product?.class_id === 6) && imagePath.length > 0
      ? defaultImage
      : imagePath?.[0]?.path

  const lowStockWarning =
    flavors.length > 0
      ? flavors.find((flavor: any) => flavor.id === product?.product?.id)?.balance <= 0
      : product?.product?.stock <= 0

  return (
    quantity > 0 && (
      <Style.Container key={product_id} isMobile={isMobile}>
        <Style.ProductInfos isMobile={isMobile}>
          <img src={selectedImage} alt="foto produto" />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {!isManualPrice && <ProgressiveDiscountBadge productId={product_id} />}
            <Style.ProductName isMobile={isMobile}>{product?.product?.translated_name}</Style.ProductName>
            {product?.product?.origin === 'pill' && <SoldByPill />}
          </div>
        </Style.ProductInfos>
        <Style.ProductProperties isMobile={isMobile}>
          <Style.Quantity>
            {!isNotEditing && !isManualPrice ? (
              <ProgressiveSingleQuantityControl
                productId={product_id}
                qty={quantity}
                stock={product?.product?.stock}
                basePrice={unitPrice}
                onSelect={(n) => handleSelect(n)}
                onRemove={() => {
                  if (!isUpdate) removeCart(product_id)
                }}
              />
            ) : (
              <div className="qtd">{quantity}</div>
            )}
          </Style.Quantity>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            {lowStockWarning && !isCarrinhoWa && (
              <Style.DeliveryWarning>
                Possível maior tempo <br /> de entrega
              </Style.DeliveryWarning>
            )}
            {!isNotEditingFlavor && !isManualPrice ? (
              <FlavorQuantitySelector
                productId={product_id}
                mainProductId={product?.product?.main_product_id}
                currentFlavorLabel={product?.product?.flavor}
              />
            ) : (
              product?.product?.flavor && (
                <Style.ProductSabor isMobile={isMobile}>{product.product.flavor}</Style.ProductSabor>
              )
            )}
          </div>

          <Style.ProductPrice isMobile={isMobile}>
            {isMobile && <span>VALOR UNITÁRIO</span>}
            <PromotionalPrice
              new_price={displayPrice}
              old_price={priceOldValue}
              discount={priceDiscount as any}
              discount_type={priceDiscountType}
            />
          </Style.ProductPrice>
          <Style.ProductTotal isMobile={isMobile}>
            {isMobile && <span>VALOR TOTAL</span>}
            {formatPriceToNumber(total)}
          </Style.ProductTotal>
        </Style.ProductProperties>
        <ModalEditProduct
          flavorSelected={flavorSelected}
          isOpen={openModal}
          closeModal={() => setOpenModal(false)}
          product={product}
          flavors={flavors}
        />
      </Style.Container>
    )
  )
}
